import {cn} from '@bem-react/classname';
import {IClassNameProps} from '@bem-react/core';
import {KitchenService} from '../../../3d/services/KitchenService/KitchenService';
import {TUserRole} from '../../../../common-code/types/TUserRole';

export const cnWizardBuy = cn('WizardBuy')
export interface IWizardBuyProps extends IClassNameProps {
    service?: KitchenService;
    user?: TUserRole;
}